import { useCallback } from "react";

import { useShowDialogWithPermissionCheck } from "../../permissions/useShowDialogWithPermissionCheck.tsx";
import { SaveTemplate as SaveTemplateContent } from "./SaveTemplate";

export type SaveTemplateOptions = {
  nodeId: number;
  /** Node whose stored canvas screenshot can be offered as the default thumbnail, when not the node itself. */
  thumbnailSourceNodeId?: number;
};

export type SaveTemplate = (options: SaveTemplateOptions) => void;

export const useSaveTemplate = (): SaveTemplate => {
  return useShowDialogWithPermissionCheck(
    "saveTemplates",
    useCallback(({ nodeId, thumbnailSourceNodeId }: SaveTemplateOptions, handleClose) => {
      return (
        <SaveTemplateContent
          nodeId={nodeId}
          thumbnailSourceNodeId={thumbnailSourceNodeId}
          onCancel={handleClose}
          onSaved={handleClose}
        />
      );
    }, []),
  );
};
